module.exports = __webpack_public_path__ + "img/about-sh.75bcb215.png";